<script>
import OrdersApi from "@/services/orders-api";
import AvoirRequestApi from "@/services/avoirRequest-api";
import AvoirLineEntry from "@/components/AvoirLineEntry";
import VueBarcode from 'vue-barcode';

export default {

  components: {
     VueBarcode,
     AvoirLineEntry
  },

  props: {
     onClose:{
          type:Function,
          default: null
        }, 
    title:{
          type:String,
          default: ""
        },

        showAddNewAvoirModal:{
          type:Boolean,
          default: false
        },
        isNew:{
          type:Boolean,
          default: false
        },

        propsAvoirId:{
              type:Number,
              default: null
            },

  },

  data() {
    return {
        localShowAddNewAvoirModal: this.showAddNewAvoirModal,

        pagemodel: {currentPage : 1, perPage : 10, totalRows: 0},

        ordersList: [],
        isTableLoading: false,

        orderSelected:null,
        orderLineSelected:null,
        avoir:{} ,
        avoirLines:{} ,

        start:null ,
        end:null ,
        orderLines: [] ,
        quantityAvoir:0 ,
        confirmedQuantityAvoir:0 ,
        reason:null ,
        avoirRequestId:null ,
        selectedItem: { },
        batchDate:"",
        batchNumber:"",
        showItemsModal:false ,
        itemsFilter: '',
        pagemodelMain: {currentPage : 1, perPage : 15, totalRows: 0},
        isItemsTableBusy: false,
        endOfFindItems:false,
        itemsList: [],
        itemLines: [],
        itemFields: [
        {key:"actions", label:""},
        { key:"ref", label: "Réference", sortable: false, tdClass:"text-left align-middle"},
        { key:"title", label: "Article", sortable: false, tdClass:"text-left font-weight-bold  align-middle"},
        { key:"packageCount", label:"Unités par carton", thClass:"text-right", tdClass:"text-right align-middle", thStyle:"width:150px;"}, 
        { key:"priceTaxIncl", label:"Prix TTC", thClass:"text-right ", tdClass:"text-right font-weight-bold align-middle", thStyle:"width:100px;"}, 
        
        // { key:"price", label: "P.U (TND)", sortable: false, tdClass:"text-right font-weight-bold", thClass:"text-right", thStyle:"width:150px"},
        // { key:"discount", label: "remise (TND)", sortable: false, tdClass:"text-right font-weight-bold", thClass:"text-right", thStyle:"width:150px"},
        // { key:"discountedPrice", label: "P.U.Remisé (TND)", sortable: false, tdClass:"text-right font-weight-bold", thClass:"text-right", thStyle:"width:100px"},
      ],
        //item:null,
        isAvoirSubmitted: false,
        isAddingLine: false,

    };
  },

  mounted(){

    //this.getOrders()

    var date = new Date();
      
      this.start = new Date(date.getFullYear(), date.getMonth(), 1);
      const startoffset = this.start.getTimezoneOffset()
      this.start= new Date(this.start.getTime() - (startoffset*60*1000))
      this.start=this.start.toISOString().split('T')[0]

      this.end = new Date(date.getFullYear(), date.getMonth() + 1, 0);
      const endoffset = this.end.getTimezoneOffset()
      this.end= new Date(this.end.getTime() - (endoffset*60*1000))
      this.end=this.end.toISOString().split('T')[0]
  },
  
  computed: {
        role() {
          return this.$cookies.get('userr');
        },

        linesCount() {
          return Array.isArray(this.avoirLines) ? this.avoirLines.length : 0
        },


        canDeleteLines() {
          return this.role==0 && (this.avoir.status==0)
        },

    },

  methods: {
     handlePrint() {
      document.querySelectorAll('.modal-content').forEach(el => {
        el.style.border = '1px dashed #858383';
        el.style.borderRadius = '5px';
      });

      this.$nextTick(() => {
        window.print();
      });
    },





    onCloseAddNewAvoirModal(){
      this.selectedItem = {};
      this.batchNumber=""
      this.batchDate=""

      this.onClose()

      if(this.role == 0 && this.avoirRequestId ){
        AvoirRequestApi.deleteAvoirRequestIfEmpty(this.avoirRequestId ).then(
          this.onClose()
        )
      }else{
        this.onClose()
      }
      
    }, 

    refusedAvoirRequest(){
      const status = 3 ;
      AvoirRequestApi.addRequestAvoir(this.avoirRequestId  , null , status )
        .then(avoirId => {
            if(avoirId) {
            this.avoirRequestId = avoirId 
            this.onCloseAddNewAvoirModal()
            }
          })
    },

    validateRequest(){
      AvoirRequestApi.validateRequestAvoir(this.avoir )
      .then(()=>{
        this.onCloseAddNewAvoirModal()
            })
    },

    requestAvoirStatusToLabel(status){
      switch(status){
        case 0: return 'Brouillon';
        case 1: return 'Envoyée';
        case 2:return 'Traitée';
        case 3 :return 'Refusée';
        default: return '_'
      }
    },

    requestAvoirToColor(status){
     
      switch(status){
        case 0: return 'secondary';
        case 1: return 'warning';
        case 2:return 'success';
        case 3 :return 'danger';
        default: return '_'
      }
    },

    sendNewAvoir(){
      const status = 1
      // this.showAddNewAvoirModal= true 
          AvoirRequestApi.addRequestAvoir(this.avoirRequestId  , this.reason , status )
        .then(avoirId => {
            if(avoirId) {
              this.avoirRequestId = avoirId
              this.getRequestAvoirById()
              this.isAvoirSubmitted = true;
              // this.onCloseAddNewAvoirModal()
            }
          }) 
        },
 
    addRequestAvoirLine(line){
      const lineAvoirRequest = {
                avoirId: this.avoirRequestId,
                itemId: line.item.id,
                quantityAvoir: line.quantityAvoir,
                reason: line.reason,
                batchNumber: line.batchNumber,
                batchDate: line.batchDate,
      };

      this.isAddingLine = true
      AvoirRequestApi.addRequestAvoirLine(lineAvoirRequest )
          .then((avoirId)=>{
            if (avoirId) {
              this.avoirRequestId = avoirId
              this.getRequestAvoirById()
              this.$refs.lineEntry && this.$refs.lineEntry.reset()
            }
          })
          .finally(() => { this.isAddingLine = false })
    } , 

    removeAvoirLine(line){
        const lineAvoirRequest = {
                    avoirId: this.avoirRequestId,
                    itemId: line.itemId ,
                    quantityAvoir:line.quantityAvoir,
          };
            AvoirRequestApi.deleteAvoirRequestLine(lineAvoirRequest )
            .then(()=>{
                this.getRequestAvoirById()
            } )
            }, 

    getOrderLines(orderId){
      OrdersApi.getOrderLines(orderId).then(
      order => {
          if (order){
          this.orderLines=order.lines
          }}
      )
      },

    getRequestAvoirById(){
      AvoirRequestApi.getRequestAvoirById(this.avoirRequestId  ).then(
        result => {
            if (result){

            this.avoir=result
            this.reason = result.reason
            this.avoirLines =result.lines ?  result.lines : []
            } }
        )},

    getOrders() {
      this.isTableLoading = true
      
      if(this.role==0){
        const status = 3 ;

      OrdersApi.getOrdersByCustomer(this.pagemodel.currentPage, this.pagemodel.perPage,this.supplierId, false,status,this.isCurrent,this.start,this.end, this.channel ,true)
      .then(orders => {
        if(orders){
          this.ordersList =orders.list ;
          this.pagemodel.totalRows = orders.total;
          this.pagemodel.currentPage = orders.page;
          this.pagemodel.perPage = orders.pageSize;
          this.pagemodel.pageSize = orders.pageSize;
        }
      })
      .finally(() => {
        this.isTableLoading=false 
      })
      }
    }, 
    },

    watch: {
     // invoices-list creates this modal only when it opens (v-if), so this must also run on creation:
     // otherwise an existing request opens empty, because its lines are loaded here
     showAddNewAvoirModal: {
      immediate: true,
      handler(isOpen) {
      this.avoirRequestId = this.propsAvoirId
      this.localShowAddNewAvoirModal = isOpen;
      this.orderSelected = null
      if (this.isNew){
        this.reason=null
      }
      this.avoirLines ={}
      if(isOpen && this.avoirRequestId){
        this.getRequestAvoirById(this.avoirRequestId)
      }
      
      },
    }, 

    end: function(){
          if((this.end  && this.start) || (!this.end  && !this.start) ){
            this.getOrders()
          }   
        },
    start: function(){
        if((this.end && this.start) || (!this.end  && !this.start)  ){
        this.getOrders()
        }
    },

     orderSelected: function(){
        this.orderLineSelected = null;
        if (this.orderSelected){       
            this.getOrderLines(this.orderSelected.id);
            this.quantityAvoir = 0
        }    
    }, 

      orderLineSelected: function(){
        if (this.orderLineSelected){       
            this.quantityAvoir = 0
        }    
      }, 

  },
  
};
</script>

<template>

<b-modal
            v-model="localShowAddNewAvoirModal"
            :title="this.title" 
          
            title-class="text-primary"
            title-tag="h5"
            header-close-variant="danger"
            size="xl"
            no-close-on-backdrop
            @hide="onCloseAddNewAvoirModal"      
            hide-footer
            >

            <div class="d-none d-print-block mb-4 text-dark">

              <div class="row">
                <div class="col-6">
                  <h3 class="font-weight-bold text-dark">DEMANDE D'AVOIR</h3>
                <span class="font-size-16 text-dark">N° <strong>{{avoir.avoirId}}</strong></span>
                </div>

                <div class="col-6 text-right">
                  <vue-barcode
                    v-if="avoir.avoirId"
                        :value="avoir.avoirId"
                        :width="2"  :height="50" 
                        background="transparent"
                        fontSize="16" >
                      </vue-barcode>

                </div>

              </div>

              <h5 class="font-weight-bold mt-4 text-dark">CLIENT</h5>
              <span class="text-dark">{{this.avoir.customer}}</span>

              <h5 class="font-weight-bold mt-4 text-dark">DATE</h5>
              <span class="text-dark">{{this.avoir.date}}</span>

              <h5 class="font-weight-bold mt-4 text-dark">NBRE ARTICLES</h5>
              <span class="text-dark">{{this.avoir.avoirLinesCount}}</span>

          </div>

    <!-- summary: number, date, status, client -->
    <div v-if="avoir && avoir.avoirId" class="avoir-req__summary d-print-none">
      <div class="avoir-req__summary-item">
        <span class="avoir-req__summary-label">Demande N°</span>
        <span class="avoir-req__summary-value">{{ avoir.avoirId }}</span>
      </div>
      <div v-if="avoir.date" class="avoir-req__summary-item">
        <span class="avoir-req__summary-label">Date</span>
        <span class="avoir-req__summary-value">{{ avoir.date }}</span>
      </div>
      <div v-if="role==1 && avoir.customer" class="avoir-req__summary-item">
        <span class="avoir-req__summary-label">Client</span>
        <span class="avoir-req__summary-value">{{ avoir.customer }}</span>
      </div>
      <div class="avoir-req__summary-item">
        <span class="avoir-req__summary-label">Articles</span>
        <span class="avoir-req__summary-value">{{ linesCount }}</span>
      </div>
      <div class="avoir-req__summary-item">
        <span class="avoir-req__summary-label">État</span>
        <span><b-badge :variant="requestAvoirToColor(avoir.status)" class="font-size-12">{{ requestAvoirStatusToLabel(avoir.status) }}</b-badge></span>
      </div>
    </div>

    <!-- new line -->
    <AvoirLineEntry v-if="(isNew && !isAvoirSubmitted) || (this.role==0 && avoir.status==0)" ref="lineEntry" class="d-print-none" :busy="isAddingLine" @add="addRequestAvoirLine" />

    <!-- lines -->
    <div class="avoir-req__lines-title d-print-none">
      <h6 class="mb-0 font-weight-bold text-dark">Articles de la demande</h6>
      <span class="text-muted font-size-13">{{ linesCount }} ligne{{ linesCount > 1 ? 's' : '' }}</span>
    </div>
    <div class="table-responsive avoir-req__table-wrap">
        <table class="table avoir-req__lines">
          <thead>
            <tr>
              <th>Article</th>
              <th>Numéro Lot</th>
              <th>Date Lot</th>
              <th class="text-right">Quantité</th>
              <th>Motif de la demande</th>
              <th v-if="canDeleteLines" class="d-print-none" style="width:60px;"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="!linesCount">
              <td :colspan="canDeleteLines ? 6 : 5" class="avoir-req__empty">
                <i class="fas fa-box-open"></i>
                Aucun article dans cette demande.
                <span v-if="(isNew && !isAvoirSubmitted) || (this.role==0 && avoir.status==0)">Ajoutez un article avec le formulaire ci-dessus.</span>
              </td>
            </tr>
            <tr v-for="(line,i) in this.avoirLines" :key="i">
              <td>
                <div class="font-weight-bold">{{line.itemTitle}}</div>
                <span class="font-size-12 text-muted">Réf : {{ line.itemRef }}</span>
              </td>
              <td>{{ line.batchNumber || '—' }}</td>
              <td class="text-nowrap">{{ line.batchDate || '—' }}</td>
              <td class="text-right avoir-req__qty">{{ line.quantityAvoir }}</td>
              <td>{{ line.reason }}</td>
              <td v-if="canDeleteLines" class="text-center d-print-none">
                <b-button size="sm" variant="outline-danger" title="Supprimer la ligne" @click="removeAvoirLine(line)">
                  <i class="mdi mdi-trash-can font-size-16"></i>
                </b-button>
              </td>
            </tr>
          </tbody>
        </table>
    </div>

    <div class="avoir-req__footer d-print-none">
      <div class="avoir-req__hint">
        <span v-if="role==0 && avoir && avoir.status === 0">
          <i class="mdi mdi-information-outline mr-1"></i>Demande enregistrée en brouillon : cliquez sur « Envoyer la demande » pour la transmettre.
        </span>
      </div>
      <div class="avoir-req__actions">
        <b-button variant="outline-secondary" @click="handlePrint" v-if="avoir && avoir.status">
          <i class="fa fa-print font-size-14 align-middle mr-2"></i>{{$t("order.buttons.print")}}
        </b-button>

        <b-button variant="success" @click="sendNewAvoir" v-if="role==0 && avoir && avoir.status === 0" :disabled="!linesCount">
          <i class="fas fa-paper-plane font-size-14 align-middle mr-2"></i><span class="font-weight-bold">Envoyer la demande</span>
        </b-button>

        <b-button variant="success" @click="validateRequest" v-if="role==1 && avoir && avoir.status != 2">
          <i class="fas fa-check-circle font-size-14 align-middle mr-2"></i><span class="font-weight-bold">Clôturer</span>
        </b-button>
      </div>
    </div>



        </b-modal>

</template>


<style>

@media print {
  .modal-header {
      display: none !important;
  }
  
}

</style>
<style src="./avoir-request.css"></style>
